import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { OAuthModule } from 'angular-oauth2-oidc';
import { AppApiModule } from '../services/api.module';
import { AuthGuard } from './auth.guard';
import { AuthService } from './auth.service';
import { SignInOidcComponent } from './components/signin-oidc.component';
import { UnauthorisedComponent } from './components/unauthorised.component';

@NgModule({
  imports: [
    HttpClientModule,
    OAuthModule.forRoot(),
    AppApiModule
  ],
  declarations: [
    SignInOidcComponent,
    UnauthorisedComponent
  ],
  providers: [
    AuthService,
    AuthGuard
  ]
})
export class AuthModule { }
